import React from 'react';
import { Checkbox } from 'antd-v5';
import PropTypes from 'prop-types';

const OPTIONS = [
  { label: 'Email', value: 'EMAIL' },
  { label: 'SMS', value: 'SMS' },
];

const ContactMethodFilter = ({ value, onChange }) => {
  return (
    <div className="audience-filter-section">
      <div className="audience-filter-label">Contact Methods</div>
      <Checkbox.Group options={OPTIONS} value={value || []} onChange={onChange} />
    </div>
  );
};

ContactMethodFilter.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

ContactMethodFilter.defaultProps = {
  value: [],
};

export default ContactMethodFilter;
